export default __webpack_public_path__ + "static/media/twitter.aa05270a.svg";